import { fetchServer as fetchServerOriginal } from '@/features/utils/fetch.ts'

export const fetchServer = async (url: string, options: RequestInit = {}) => {
  return { data: await (await fetchServerOriginal(url, options)).json() }
}
